<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Basic Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr>
                                <th class="listHeader tableLinerT" style="width:20%">National</th>
                                <td class="tableLinerT text-left pl-5" style="width:30%">{{NAT_NAME}} ({{FAC_NAME}})</td>
                                <th class="listHeader tableLinerT" style="width:20%">Approval User</th>
                                <td class="tableLinerT text-left pl-5" style="width:30%">
                                    <!--
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="CTR_USR_ID" :items="managerList" item-text="info" item-value="vals" label="Manage User" outlined dense single-line hide-details></v-select>
                                    -->
                                     <MngSelect @mngID="mngListUpt"/>
                               </td>
                           </tr>
                           <tr>
                                <th class="listHeader">Model</th>
                                <td class="text-left pl-5">{{EBK_MODEL_NAME}}</td>
                                <th class="listHeader" >Vehicle Identification Number</th>
                                <td class="text-left pl-5">{{EBK_IDTFY_NUMS}}</td>
                           </tr>
                           <tr>
                                <th class="listHeader">VCU ID</th>
                                <td class="text-left pl-5">{{VCU_ID}}</td>
                                <th class="listHeader">MCU ID</th>
                                <td class="text-left pl-5">{{MCU_ID}}</td>
                           </tr>
                           <tr>
                                <th class="listHeader">Battery ID 1</th>
                                <td class="text-left pl-5">{{CELL_ID1}}</td>
                                <th class="listHeader">Battery ID 2</th>
                                <td class="text-left pl-5">{{CELL_ID2}}</td>
                           </tr>
                           <tr>
                                <th class="listHeader">Status</th>
                                <td class="tableLinerB text-left pl-5">{{CTR_INFO}}</td>
                                <th class="listHeader tableLinerB">Registration Date</th>
                                <td class="tableLinerB text-left pl-5">{{INS_DTM}}</td>
                           </tr>
                           </tbody>
                       </v-simple-table>
                    </v-card>
  
                    <v-card elevation="1" class="mt-3 pa-5" >
                        <h3>Contact Info</h3>
                        <v-simple-table>
                            <tbody>
                            <tr>
                                <th class="listHeader tableLinerT" style="width:20%">Classification</th>
                                <td class="tableLinerT text-left pl-5" style="width:30%;">
                                   <v-select style="font-size:13px;" class="align-self-center mr-3" v-model="CTR_USR_TYPE" :items="usrClsList" item-text="info" item-value="vals" label="Classification" outlined dense single-line hide-details v-on:change="changeUsrCls"></v-select>
                                </td>
                                <th class="listHeader tableLinerT" style="width:20%">Vehicle Number</th>
                                <td class="text-left pl-5">
                                    <v-text-field v-model="CTR_EBK_NUM" outlined dense single-line hide-details small placeholder="Vehicle Number" maxlength="20"></v-text-field>
                                </td>
                            </tr>
                            <tr v-if="CTR_USR_TYPE==2">
                                <th class="listHeader " style="width:20%">Company</th>
                                <td class="tableLinerT text-left pl-5" style="width:30%;">
                                    <v-text-field v-model="CTR_USR_COMPANY_NAME" outlined dense single-line hide-details small placeholder="Company" maxlength="100"></v-text-field>
                                </td>
                                <th class="listHeader " style="width:20%">Corporate Registration Number</th>
                                <td class=" text-left pl-5" style="width:30%;">
                                    <v-text-field v-model="CTR_USR_COMPANY_NUM" outlined dense single-line hide-details small placeholder="Company"  maxlength="50"></v-text-field>
                                </td>
                            </tr>
                            <tr>
                                <th class="listHeader">Name</th>
                                <td class="text-left pl-5">
                                     <v-text-field v-model="CTR_USR_NM" outlined dense single-line hide-details small placeholder="Name" maxlength="80"></v-text-field>
                                </td>
                                <th class="listHeader" >Birth</th>
                                <td class="text-left pl-5">
                                    <v-text-field v-model="CTR_USR_BIRTH" outlined dense single-line hide-details small placeholder="Birth" minlength="8" maxlength="8"></v-text-field>
                                </td>
                            </tr>
                            <tr>
                                <th class="listHeader">Tel</th>
                                <td class="text-left pl-5">
                                    <v-text-field v-model="CTR_USR_TEL" outlined dense single-line hide-details small placeholder="Tel" maxlength="30"></v-text-field>
                                </td>
                                <th class="listHeader">Phone</th>
                                <td class="text-left pl-5">
                                    <v-text-field v-model="CTR_USR_PHONE" outlined dense single-line hide-details small placeholder="Phone" maxlength="30"></v-text-field>
                                </td>
                            </tr>
                            <tr>
                                <th class="listHeader">Email</th>
                                <td class="tableLinerB text-left pl-5" colspan="3">
                                    <v-text-field v-model="CTR_USR_EMAIL" outlined dense single-line hide-details small placeholder="Email" maxlength="100"></v-text-field>
                                </td>
                            </tr>
                            <tr>
                                <th class="listHeader">Address</th>
                                <td class="text-left pl-5" colspan="3">
                                    <div class="d-flex flat ">
                                        <div class="mr-3" style="width:100px;">
                                            <v-text-field v-model="CTR_USR_POST" outlined dense single-line hide-details small placeholder="post" maxlength="10"></v-text-field>
                                        </div>
                                        <div class="mr-3" style="width:45%">
                                            <v-text-field v-model="CTR_USR_ADDR1" outlined dense single-line hide-details small placeholder="Address" maxlength="100"></v-text-field>
                                        </div>
                                        <div class="mr-5" style="width:45%">
                                            <v-text-field v-model="CTR_USR_ADDR2" outlined dense single-line hide-details small placeholder="Address detail" maxlength="100"></v-text-field>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="listHeader">Registration Date</th>
                                <td class="tableLinerB text-left pl-5">
                                    <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu 
                                        ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        :return-value.sync="s_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="150px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field 
                                            v-model="s_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="d-flex align-self-center mt-0 pt-0"
                                            style="font-size:13px; "
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="s_date" no-title scrollable :max="e_date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="s_date_search(s_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                </td>
                                <th class="listHeader tableLinerB">Expiration Date</th>
                                <td class="tableLinerB text-left pl-5">
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu
                                        ref="menu2"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :return-value.sync="e_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="220px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            v-model="e_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="align-self-center ma-0 pa-0"
                                            style="font-size:13px;width:190px;"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="e_date" no-title scrollable :min="s_date" >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="e_date_search(e_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                </td>
                            </tr>
                            </tbody>
                        </v-simple-table>

                        <div class="d-flex justify-space-between dense pa-0 mt-10">
                            <div class="pa2 " >
                                <v-btn dark class="backBtn px-5" @click="goBack" >Back</v-btn>
                            </div>
                        
                            <div class="pa2 ">
                                <v-btn dark class="registerBtn ml-2 px-6" @click="regRLSInfo()">Save</v-btn>
                            </div>
                        </div>
                    </v-card>

                    
                </div>
            </div>
        </div>
        <Footer/>


        <!-- Alert Dialog / Save -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="alertFlag" width="450">
                <v-card>
                    <v-card-title class="text-subtitle-2 pb-0 text-wrap d-flex flat" style="width:450px;">
                        <v-icon class='d-flex' style='color:red;'>mdi-alert </v-icon>
                        <span class="d-flex pl-3">{{alertText}}</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="alertFlag = false;regFlag='Y';alertText='';">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncSuccess-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="goList">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="asyncErrors=false;">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'
import MngSelect from '@/components/cfgManager.vue'

export default {
    name: 'VehicleRlsWrite',
    components: { Gnb, Footer, PageCrumbs,  Navs, MngSelect },
    data () {
        return {
            // login Info
            gnbCode:"1", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:2, navCode2:21, 
            // Page Title & Breadcrumbs
            pTitles: "New Contract Registration",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Contract Management', disabled: true,}, { text: 'New Contract Registration', disabled: false,}],
            NavList: [
              {
                items: [
                  { title: 'Vehicle List', nums:11, href:'/Vehicle', icons:'mdi-format-list-bulleted' },
                  { title: 'New Registration', nums:12, href:'/VehicleWrite', icons:'mdi-lead-pencil' },
                ],
                title: 'Vehicle Management', nums: '1'
              },
              {
                items: [
                  { title: 'Contract List',nums:21, href:'/VehicleRLS', icons:'mdi-format-list-bulleted' },
                  { title: 'New Contract Registration', nums:22, href:'/VehicleRLS2', icons:'mdi-lead-pencil' },
                ],
                title: 'Contract Management', nums: '2'
              },
            ], 
            date: new Date().toISOString().substr(0, 10), 
            s_date: "", e_date: "", menu1: false, menu2: false,

            asyncActType: "C",
            schEbkSeq:'',
            EBK_SEQ: "", NAT_NAME: "",FAC_NAME: "",EBK_MODEL_NAME: "",EBK_IDTFY_NUMS: "",
            VCU_ID: "",MCU_ID: "",CELL_ID1: "",CELL_ID2: "",APRV_STATUS: "",INS_DTM: "",INS_USR_ID: "",INS_USR: "",
            CONT1:"", CONT2:"", CONT3:"", CONT4:"",
            APRV_USR_ID: "",APRV_USR: "",APRV_DTM: "", APRV_INFO:"",

            /*managerList:[{info:'admin', vals:'admin'},{info:'manager', vals:'manager'}],*/
            managerList:[],
            usrClsList:[{info:'B2C', vals:1}, {info:'B2B',vals:2}],

            CTR_USR_COUNTRY_CODE:"", CTR_USR_COUNTRY:"", CTR_USR_TYPE: "",
            CTR_USR_NM: "", CTR_USR_COMPANY_NAME:"", CTR_USR_COMPANY_NUM:"", CTR_DT:"", CTR_USR_BIRTH:"",
            CTR_USR_POST:"", CTR_USR_ADDR1:"", CTR_USR_ADDR2:"", CTR_USR_TEL: "", CTR_USR_PHONE: "", CTR_USR_EMAIL: "", CTR_STATUS: "1", CTR_EBK_NUM: "", CTR_INFO:"", CTR_EXP_DTM:"",CTR_USR_ID:"",

            
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false,
           
            emptyFlag:true, emptyFlag2:true, regFlag:'Y',
            alertText:"", alertFlag:false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.schEbkSeq);
        //console.log('param 확인2' + this.$route.params.asyncActType);
        this.schEbkSeq = this.$route.params.schEbkSeq;
        this.asyncActType = this.$route.params.asyncActType;
        if(this.schEbkSeq == '') {
            this.schEbkSeq = localStorage.getItem('selectEbkSeq');
        }
        if(this.schEbkSeq != '') {
            this.getInfo();
        } else {
            alert("Not Data");
            this.$router.replace('VehicleRLS2');
        }
        window.scrollTo(0, 0);
        this.cfgManageUsrList();
    },

    methods : {

        mngListUpt(arg){
            this.CTR_USR_ID = arg;
            //console.log("CTR_USR_ID="+this.CTR_USR_ID);
        },    

        // datepicker 
        setSchDate(arg) {
            if(arg == 1) {
                this.s_date = new Date().toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 2) {
                let now = new Date();
                this.s_date =  new Date(now.setMonth(now.getMonth() - 1));
                this.s_date = this.s_date.toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 3) {
                this.s_date = '';
                this.e_date = '';
            }
        },

        // datepicker - sub
        s_date_search(v) {
            this.s_date = v;
            this.menu1 = false;
            this.$refs.menu1.save(v);
        },

        // datepicker - sub
        e_date_search(v) {
            this.e_date = v;
            this.menu2 = false;
            this.$refs.menu2.save(v);
        },

        // API Async 
        getInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "ebkSeq": this.schEbkSeq
                })
            };
            /*
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "ebkSeq": this.schEbkSeq
                }));
            */
            fetch('https://api.e3bss.com/_APP/POC/eBikeRLS.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                if(json.result == "success") {
                    this.EBK_SEQ = json.EBK_SEQ; this.NAT_NAME = json.NAT_NAME; this.FAC_NAME = json.FAC_NAME; 
                    this.EBK_MODEL_NAME = json.EBK_MODEL_NAME; this.EBK_IDTFY_NUMS = json.EBK_IDTFY_NUMS;
                    this.VCU_ID = json.VCU_ID; this.MCU_ID = json.MCU_ID; this.CELL_ID1 = json.CELL_ID1; this.CELL_ID2 = json.CELL_ID2; 
                    this.APRV_STATUS = json.APRV_STATUS;
                    this.INS_DTM = json.INS_DTM; this.INS_USR_ID = json.INS_USR_ID; this.INS_USR = json.INS_USR;
                    this.APRV_USR_ID = json.APRV_USR_ID; this.APRV_USR = json.APRV_USR; this.APRV_DTM = json.APRV_DTM;
                    this.APRV_INFO = json.APRV_INFO;
                    this.CTR_USR_COUNTRY_CODE = json.CTR_USR_COUNTRY_CODE;
                    this.CTR_USR_COUNTRY = json.CTR_USR_COUNTRY;
                    this.CTR_USR_TYPE = Number(json.CTR_USR_TYPE);
                    this.CTR_USR_NM = json.CTR_USR_NM;
                    this.CTR_USR_COMPANY_NAME = json.CTR_USR_COMPANY_NAME;
                    this.CTR_USR_COMPANY_NUM = json.CTR_USR_COMPANY_NUM;
                    this.s_date = this.CTR_DT = json.CTR_DT;
                    this.e_date = this.CTR_EXP_DTM = json.CTR_EXP_DTM;
                    this.CTR_USR_BIRTH = json.CTR_USR_BIRTH;
                    this.CTR_USR_POST = json.CTR_USR_POST;
                    this.CTR_USR_ADDR1 = json.CTR_USR_ADDR1;
                    this.CTR_USR_ADDR2 = json.CTR_USR_ADDR2;
                    this.CTR_USR_TEL = json.CTR_USR_TEL;
                    this.CTR_USR_PHONE = json.CTR_USR_PHONE;
                    this.CTR_USR_EMAIL = json.CTR_USR_EMAIL;
                    this.CTR_EBK_NUM = json.CTR_EBK_NUM;
                    this.CTR_USR_ID = json.CTR_USR_ID;
                    this.CTR_INFO = json.CTR_INFO;
                    if(json.CTR_INFO != '') {
                        this.CTR_INFO = json.CTR_INFO;
                    } else {
                        this.CTR_INFO = "출고대기";
                    }
                    this.emptyFlag = false;
                } else {
                    this.emptyFlag = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        changeUsrCls() {
            this.CTR_USR_COMPANY_NAME="";
            
        },

        cfgManageUsrList() {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                })
            };
            /*
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                }));
            */
            fetch('https://api.e3bss.com/_APP/POC/cfg_musr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                if(json.result == "success") {
                    this.managerList=[];
                    this.managerList=json.value.list;
                    this.emptyFlag2 = false;
                } else {
                    this.emptyFlag2 = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        // back button
        goList() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'VehicleRLS2'});
        },

        // back button
        goBack() {
            //console.log('back');
            if(this.asyncActType=="U") {
                this.$router.push({ name: 'VehicleRlsDetail', params: { ebkSeq: this.schEbkSeq }})
            } else {
                return this.$router.go(-1);
            }
            //this.$router.push({ name: 'VehicleRLS2'});
        },

        regRLSInfo() {
            //alert('aaaaa');
            if(this.CTR_USR_TYPE == '') {
               // alert('BBBB');
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Classification');
                return;
            }
            
            if(this.CTR_USR_TYPE == 2 && (this.CTR_USR_COMPANY_NAME == "" || this.CTR_USR_COMPANY_NAME == undefined)) {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Company Name');
                return;
            }

            if(this.CTR_USR_TYPE == 2 && (this.CTR_USR_COMPANY_NUM == "" || this.CTR_USR_COMPANY_NUM == undefined)) {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Corporate Registration Number');
                return;
            }

            if(this.CTR_USR_NM == '' || this.CTR_USR_NM == undefined ) {
                // alert('CCCC');
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Name');
                return;
            }
            if(this.CTR_EBK_NUM == '' || this.CTR_EBK_NUM == undefined) {
                //   alert('DDDD');
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Vehicle Number');
                return;
            }
            //console.log(this.CTR_USR_BIRTH);
            if(this.CTR_USR_BIRTH == '' || this.CTR_USR_BIRTH == undefined ) {
                // alert('ee');
                    this.regFlag='N'; this.alertFlag=true;
                    this.alertToForm('1', 'Birth ');
                    return;
                
            }
            if(this.CTR_USR_TEL == '' || this.CTR_USR_TEL == undefined) {
                // alert('ff');
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Tel');
                return;
            }
            if(this.CTR_USR_PHONE == ''  || this.CTR_USR_PHONE == undefined) {
                // alert('gg');
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Phone');
                return;
            }
            if(this.CTR_USR_EMAIL == ''  || this.CTR_USR_EMAIL == undefined) {
                // alert('hh');
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Email');
                return;
            }
            if(this.CTR_USR_ADDR1 == '' || this.CTR_USR_ADDR1 == undefined) {
                // alert('ii');
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Addr');
                return;
            }
            if(this.s_date == ''  || this.s_date == undefined) {
                // alert('hh');
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Registration Date');
                return;
            }
            /*
            if(this.e_date == ''  || this.e_date == undefined) {
                // alert('hh');
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Expiration Date');
                return;
            }     
            */       

            //console.log("regFlag="+this.regFlag);
            if(this.regFlag=="Y") {
                var param =JSON.stringify({ "usrID": this.loginInfo1
                        , "authCode": this.loginInfo3
                        , "act": this.asyncActType
                        , "ctrUsrType": this.CTR_USR_TYPE
                        , "ctrUsrCompanyName": this.CTR_USR_COMPANY_NAME
                        , "ctrUsrCompanyNum" : this.CTR_USR_COMPANY_NUM
                        , "ctrUsrName": this.CTR_USR_NM
                        , "ctrEbkNum": this.CTR_EBK_NUM
                        , "ctrUsrBirth": this.CTR_USR_BIRTH
                        , "ctrUsrTel": this.CTR_USR_TEL
                        , "ctrUsrPhone": this.CTR_USR_PHONE
                        , "ctrUsrEmail": this.CTR_USR_EMAIL
                        , "ctrUsrPost": this.CTR_USR_POST
                        , "ctrUsrAddr1": this.CTR_USR_ADDR1
                        , "ctrUsrAddr2": this.CTR_USR_ADDR2
                        , "ctrDTM": this.s_date
                        , "ctrExpDTM": this.e_date
                        , "ctrStatus": this.CTR_STATUS
                        , "ctrUsrID" : this.CTR_USR_ID
                        , "ebkSeq": this.schEbkSeq
                    });
                //console.log("param="+param);
                var requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: param
                };
                
                fetch('https://api.e3bss.com/_APP/POC/eBikeRLS.php', requestOptions)
                .then((response) => {
                    if(response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok');
                }).then((json) => {
                    //console.log(json);
                    //console.log(json.value.list );
                    if(json.result == "success") {
                        this.asyncSuccess=true;
                    } else {
                        this.asyncErrors = true;
                    }  
                }).catch(() => {
                    this.asyncErrors = true;
                    //console.log(error);
                });
            }
        },

        alertToForm(arg1, arg2) {
           // console.log('aa');
            var str1 = "enter";
            var strInfo1 = "Please"; var strInfo2 = "information";
            if(arg1 == 2) str1 = 'select';
            this.alertText = strInfo1 +' '+ str1 +' '+ arg2 +' '+ strInfo2+".";
            // Please select country information 
        }

    }

}
</script>
